<template>
  <v-dialog v-model="display" width="980px">
    <v-card>
      <v-card-title>
        <span class="headline">Comments</span>
      </v-card-title>
      <v-card-text v-if="comments && comments.length > 0">
        <v-list>
          <v-list-item v-for="comment in comments" :key="comment.id">
            <v-list-item-content>
              <v-list-item-title>{{ comment.user.username }} ({{ comment.timestamp }}) ></v-list-item-title>
              <v-list-item-subtitle>{{ comment.comment }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean
    },
    comments: {
      type: Array
    }
  },
  data: function() {
    return {
      display: this.open
    };
  },
  watch: {
    display: function(newVal) {
      this.$emit("update:open", newVal);
    },
    open: function() {
      this.display = this.open;
    }
  }
};
</script>

<style></style>
